export class OrganiserDetails {
organiserCapacity: number;
organiserClass: null;
organiserClassCode: number;
organiserCode: number;
organiserCurrentStatus:string;
organiserDetailsName: string;
organiserLocation: null;
organiserLocationCode: number;
organiserOccupiedTime: string;
refNo: number;
timeStamp: string;

walkInOrDelivery: boolean;
}
